import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from 'chart.js';
import { Line } from 'react-chartjs-2';
import classes from './TotalWordsGraph.module.css';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
export var options = {
    responsive: true,
    plugins: {
        title: {
            display: true,
            text: 'График слов',
        },
    },
};
var labels = [1, 2, 3, 4, 5, 6, 7];
export var data1 = {
    labels: labels,
    datasets: [
        {
            label: 'за весь период обучения',
            data: [10, 25, 38, 14, 75, 36, 87, 87],
            borderColor: '#fffff',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
    ],
};
export function TotalWordsGraph(_a) {
    var data = _a.data;
    return React.createElement(Line, { className: classes.line, options: options, data: data });
}
